import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match, RouteComponentProps } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { MenuIndice } from "app/features/componentes/menu/index";
import { catalogos } from "./catalogos";

export class IndexCatalogos extends React.PureComponent<RouteComponentProps<any>> {
    render() {
        return <MenuIndice titulo="Catálogos" submenus={catalogos} {... this.props} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/menu/view.tsx